export default "{\n    \"label\": \"Categorías\",\n    \"placeholderText\": \"Seleccione categorías\"\n}\n"